import { AccordionActionCardsBlock } from 'components/blocks/ActionCards';
import InfoCardsBlock from 'components/blocks/InfoCards';
import { AccordionRichTextBlock } from 'components/blocks/RichText';
import { AccordionSplitInfoCardBlock } from 'components/blocks/SplitInfoCard';
import { m, mapBlocksInternal, MappingEntry } from './mappingUtils';

const ACCORDION_MAPPING: MappingEntry[] = [
  m('action_cards', AccordionActionCardsBlock),
  m('split_info_card', AccordionSplitInfoCardBlock),
  m('rich_text', AccordionRichTextBlock),
  m('info_cards', InfoCardsBlock),
];

const mapNestedAccordionBlocks = mapBlocksInternal(ACCORDION_MAPPING);
export default mapNestedAccordionBlocks;
